import styled from 'styled-components';
import {device, fadeIn, font} from '@/styles/template';

export const TestingContainer = styled.div`
  &.animate {
    opacity: 0;
    animation: ${fadeIn} 0.2s 0.2s ease-in forwards;
  }
`;

export const TestingQuestion = styled.div`
    ${font.mobile.h2};
  
    ol {
        list-style-type: none;
        list-style-type: decimal !ie; /*IE 7- hack*/
        padding: 2rem 0;
        counter-reset: li-counter;
    }
    
    ol li {
        padding-left: 6rem;
        margin-bottom: 2rem;
        position: relative;
    }
    
    ol li:before {
        ${font.text.captionSmall};
        margin: 0.5rem 3rem 0 0;
        content: counter(li-counter);
        counter-increment: li-counter;
        border-radius: 50%;
        position: absolute;
        left: 0;
        display: flex;
        width: 4rem;
        height: 4rem;
        align-content: center;
        align-items: center;
        justify-content: center;
        line-height: 4rem;
        white-space: nowrap;
        border: 1px solid white;
    }
    
    ul {
        list-style-type: none;
        padding: 2rem 0;
    }
    
    ul li {
        padding-left: 3rem;
        margin-bottom: 2rem;
        position: relative;
    }
    
    ul li:before {
        content: '•';
        font-size: 3rem;
        position: absolute;
        left: 0;
        top: 0;
    }
  
    @media ${device.tablet} {
      ${font.desktop.h2};
    }
`;

export const TestingAnswers = styled.div`
  
`;

export const TestingMainImage = styled.img`
    display: block;
    max-width: 100%;
    width: auto;
    min-height: auto;
    margin: 0 auto;

    @media ${device.tablet} {
        max-width: 600px;
        max-height: 35vh;
    }
    
    &.illustrative {
        @media ${device.tablet} {
            grid-area: img;
        }
    }
`;



